import React, { ReactElement } from 'react';
import {
  Col, Link, Row, Text,
} from 'idsk-react-components';
import './legislativnyMaterialDetailRow.scss';
import SuvisiaciProces from '../../../../../../model/legislativnyMaterial/SuvisiaciProces';
import routes from '../../../../../../routing/routes';
import splitCisloLegMaterialu from '../../../../../../function/splitCisloLegMaterialu';

interface Props {
  data: SuvisiaciProces[];
}

const SuvisiaciProcesList = ({
  data,
}: Props): ReactElement => {
  if (data.length === 1) {
    const { type, year, index } = splitCisloLegMaterialu(data[0].cisloLp);
    return (
      <Row className="material-detail-row">
        <Col width="one-third">
          <Text type="span" className="information-header">Súvisiace procesy</Text>
        </Col>
        <Col width="two-thirds">
          <Text type="p" className="material-detail-row-text">{data[0].cisloLp}</Text>
          <Link
            to={routes.procesy.detail.withParams(type, year, index)}
            target="_top"
          >
            {data[0].nazov}
          </Link>
        </Col>
      </Row>
    );
  }

  if (data.length === 0) {
    return (<></>);
  }

  return (
    <Row className="material-detail-row">
      <Col width="one-third">
        <Text type="span" className="information-header">Súvisiace procesy</Text>
      </Col>
      <Col width="two-thirds">
        <Text type="ul">
          {data.sort((a, b) => (a.cisloLp > b.cisloLp ? 1 : -1))
            .map((dataRecord) => {
              const { type, year, index } = splitCisloLegMaterialu(dataRecord.cisloLp);
              return (
                <Text
                  type="li"
                  key={dataRecord.cisloLp}
                >{dataRecord.cisloLp} <br />
                  <div className="suvisiaci-proces-list-li">
                    <Link
                      to={routes.procesy.detail.withParams(type, year, index)}
                    >{dataRecord.nazov}
                    </Link>
                  </div>
                </Text>
              );
            })}
        </Text>
      </Col>
    </Row>
  );
};

export default SuvisiaciProcesList;
